<script setup lang="ts">
/* The one country control in the panel. Berths and companies both use it, so
   the two can never offer different lists — and neither can offer a country
   the `countries` foreign key would reject, because the options ARE those
   rows. See lib/countries.ts. */
import SelectField from './SelectField.vue'
import { useCountries } from '@/lib/countries'

defineProps<{
  modelValue?: string
  label?: string
  error?: string
  hint?: string
  /** Offer a blank choice, for an optional field -- a vessel's flag. */
  optional?: boolean
}>()
const emit = defineEmits<{ 'update:modelValue': [value: string] }>()

const { countries, failed } = useCountries()
</script>

<template>
  <SelectField
    :label="label ?? 'Country'"
    :model-value="modelValue"
    :placeholder="optional ? undefined : 'Select a country'"
    :error="error ?? (failed ? 'The country list could not be loaded. Reload the page.' : undefined)"
    :hint="hint"
    :disabled="failed || countries.length === 0"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <option v-if="optional" value="">Not given</option>
    <option v-for="c in countries" :key="c.code" :value="c.code">{{ c.name }}</option>
  </SelectField>
</template>
